<template>
    <div class="title-tips" :style="{'width': width}">
        <div class="title">
            {{title}}
        </div>
        <slot name="content"></slot>
    </div>
</template>
<script>
export default {
    props: {
        title: String,
        width: String
    }
}
</script>
<style lang="scss"  >
    .title-tips{
        position: absolute;
        backdrop-filter: blur(10px);
        box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
        border: solid 1px #3942b5;
        background-color: #ffffff;
        border-radius: 4px;
        margin-top: 6px;
        box-sizing: border-box;
        z-index: 2;
        .title{
            background-color: #3942b5;
            padding: 12px 16px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 500;
        }
        .content{
            padding: 16px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/titleTips.vue